import styled from "styled-components";

export const GrowthContainer = styled.div`
  .growth-global-container {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .growth-component-container {
    flex: 1 1 0%;
    background-color: #f0f0f0;
    padding: 24px;
    min-width: 0; /* Allow flex item to shrink below content size */
    overflow-x: hidden; /* Prevent container from expanding with content */
  }
`;

export const TabContent = styled.div`
  padding: 24px;
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .each--row {
    display: flex;
    flex-direction: row;
    padding: 12px;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
  }
`;

export const TailoredTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px;
`;

export const AddOrEditFeatureModalContainer = styled.div`
  margin: 20px 0px 20px 20px; /* Remove right margin to push scrollbar to edge */
  margin-top: -10px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding-right: 20px; /* Add padding instead of margin for content spacing */

  /* Custom scrollbar styling for WebKit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    border: 1px solid #f1f1f1;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;

  .each--section {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    width: 100%;
    position: relative; /* Add this to contain absolutely positioned dropdowns */
  }

  .standard-dropdown {
    width: 100% !important;
    max-width: 100% !important;
    position: relative; /* Add positioning context */
    box-sizing: border-box;

    > div {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    /* Target the dropdown component itself */
    div[data-testid*="dropdown"],
    div[class*="dropdown"],
    div[class*="Dropdown"] {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    /* Target any input fields within */
    input {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    /* Target any wrapper divs */
    > * {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    /* Target dropdown menu - constrain the dropdown list */
    [role="listbox"],
    [role="menu"] {
      width: 100% !important;
      max-width: 100% !important;
      left: 0 !important;
      right: auto !important;
      box-sizing: border-box;
      transform: none !important;
    }

    /* Fix shadow and positioned elements */
    div[style*="position: absolute"],
    div[style*="position:absolute"] {
      width: 100% !important;
      max-width: 100% !important;
      left: 0 !important;
      right: auto !important;
      transform: none !important;
    }
  }
`;

export const CustomizedSection = styled.div`
  .all-journey-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
  }
  .chip--wrapper {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
  }
  .selected--feature--container {
    padding: 4px 8px 4px 8px;
    gap: 6px;
    border-radius: 4px;
    border: 1px solid #ddccf0;
    opacity: 0px;
    background-color: #efe6f9;
  }
  .feature--text {
    color: #4b1583 !important;
  }
  .feature--wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }
`;

export const BackgroundImageContainer = styled.div<{
  imageUrl: string;
  height?: string;
  width?: string;
}>`
  height: ${(props) => props.height || "140px"};
  background: ${(props) => (props.imageUrl ? `url(${props.imageUrl})` : "")};
  background-repeat: no-repeat;
  width: ${(props) => props.width || props.height || "140px"};
  background-size: cover;
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
